import HttpService from "./HttpService";
import { IMaterial } from "../components/Proposal/Models/IMaterial";

export interface IMaterialSearchResult {
    MaterialList: IMaterial[],
    error: any
}

export class MaterialSearch {

    private static readonly AZURE_MATERIAL_SEARCH_URL = `https://stgcs-yunio-prod.servicebus.windows.net/yunio/services/SearchMaterialIOP11`;    

    public static searchMaterial(keywords: string, isLongTextSearch: boolean = false): Promise<IMaterial[]> {
        const body = {
            keyword: keywords,
            longtext: isLongTextSearch ? 'X' : '',
            mtpos: "NORM"
        };
        return HttpService.post(MaterialSearch.AZURE_MATERIAL_SEARCH_URL, body , {
            'Authorization': 'Basic bWF0c2VhcmNoOk1AVFNlYXJjaFNUTU4xMjMh'
        }).then((results: IMaterialSearchResult) => {
            //return results?.result.map((entry, idx)=>{ return { Index: idx, ...entry}; });
            return results?.MaterialList;
        });
    }    

    public static logErrorInConsole(errorArea: string, errorObj: any) {
        this.logError(errorObj.message);
        console.log(`Error message ${errorArea}: `, errorObj.message);
        console.log(`Error Stack Trace ${errorArea}: `, errorObj.stack);
    }

    private static logError(msg: any) {
        if (console) {
            console.log(`%cERROR:`, "color:red;font-weight:bold;font-size:16px");
            console.log(msg);
        }
    }    
}

